<script>

    import { onMount } from "svelte";

    let outerEl, innerEl, textEl;
    let outer, inner = 1000;

    function animation(){
        innerEl.animate([
            { transform: `translateX(0px)`, offset: 0 },
            { transform: `translateX(${-inner}px)`, offset: 1 }
        ],{
            duration: inner * 12,
            iterations: Infinity
        });
    }
 
    const setWidth = () => {
        outer = outerEl.offsetWidth;
        setTimeout(() => {
            inner = Math.max( textEl.offsetWidth, outer );
            setTimeout(() => {
                animation();
            }, 100);
        }, 500);
	}

    onMount(()=>{
        setWidth();
    });

</script>

<svelte:window on:resize={setWidth} />

<div class="marquee">
    <div class="outer" bind:this={outerEl} style="--marquee-width:{outer}px;">
        <div class="inner" bind:this={innerEl}>

            <div class="text" bind:this={textEl}>
                {#each (new Array(10)) as x, i}
                    <span><slot /></span>
                {/each}
            </div>
            <div>
                {#each (new Array(10)) as x, i}
                    <span><slot /></span>
                {/each}
            </div>

        </div>
    </div>
</div>

<style>

    .outer {
        width: 100%;
        display: flex;
        white-space: nowrap;
        overflow: hidden;
    }
    .inner {
        display: flex;
        white-space: nowrap;
        flex: 0 0 auto;
        min-width: 100%;
    }
    .inner > div {
        box-sizing: border-box;
        flex: 0 0 auto;
        min-width: var(--marquee-width);
        display: flex;
    }
    .inner span {
        margin: 0 1em;
    }

</style>
